// check on default Array iterator
var Iterators  = require('./_iterators')
  , ITERATOR   = require('./_wks')('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/_is-array-iter.js
 **/